import React, { useEffect, useState } from "react";
import { getElementPath } from "../../helpers/dom";

export default React.memo(function Dropdown(props) {
    let {
        elemSource,
        elemCurrent,
        items: itemsProps,
        placeholder: placeholderProps,
        selected: selectedProps,
        onOpen,
        onClose,
        onSelect,
        onClick
    } = props;

    let [items, setItems] = useState(itemsProps ? itemsProps : []);
    let [selectedItem, setSelectedItem] = useState(selectedProps);
    let [placeholder, setPlaceholder] = useState(placeholderProps ? placeholderProps : "Válassz");
    let [dropdownOpen, setDropdownOpen] = useState(false);

    useEffect(() => {
        if (typeof selectedProps === "undefined" || selectedProps.length <= 0) return;
        if (selectedItem !== selectedProps) setSelectedItem(selectedProps);

        let selectedItem = items.filter(item => item.value === selectedProps);

        if (selectedItem.length > 0) {
            setPlaceholder(selectedItem[0].label);
        }
    }, [selectedProps]);

    useEffect(() => {
        // Item is not attached to DOM elem
        if (!elemSource) return;

        let lisContent = [];

        if (elemSource.dataset.placeholder) setPlaceholder(elemSource.dataset.placeholder);

        elemSource.querySelectorAll("option").forEach(item => {
            lisContent.push({ label: item.textContent, value: item.value });
        });

        setItems(lisContent);
    }, []);

    // Add global event listener for closing
    useEffect(() => {
        document.addEventListener("click", handleGlobalClick);

        return () => {
            document.removeEventListener("click", handleGlobalClick);
        };
    }, []);

    return (
        <div
            className={!elemSource ? "widget-dropdown-component" : ""}
            onClick={onClick && onClick}
        >
            <div
                className={
                    "widget-dropdown_top" +
                    (dropdownOpen ? " widget-dropdown_top--open" : "") +
                    (selectedItem ? " widget-dropdown_top--selected" : "")
                }
                style={{ borderRadius: 8, backgroundColor: "rgba(18, 25, 77, 0.1)" }}
                onClick={toggleOpen}
            >
                {placeholder}
            </div>
            <ul
                className={
                    "widget-dropdown_list" + (dropdownOpen ? " widget-dropdown_list--open" : "")
                }
                style={{ right: 0, top: 70, borderRadius: 8, overflow: "hidden" }}
            >
                {items.map((item, index) => {
                    return (
                        <li
                            key={index}
                            className={selectedItem === item.value ? "selected" : ""}
                            onClick={() => {
                                handleOnSelect(item.label, item.value);
                            }}
                        >
                            {item.label}
                        </li>
                    );
                })}
            </ul>
        </div>
    );

    function handleGlobalClick(e) {
        // console.log(e, getElementPath(e.target));
        let pathArray = getElementPath(e.target);
        if (!pathArray.some(elem => /widget-dropdown/g.test(elem))) {
            setDropdownOpen(false);
        }
    }

    function toggleOpen() {
        setDropdownOpen(!dropdownOpen);

        if (dropdownOpen) {
            handleOnClose();
        } else {
            handleOnOpen();
        }
    }

    function handleOnOpen() {
        onOpen && onOpen();

        if (elemCurrent) {
            elemCurrent.dispatchEvent(new CustomEvent("opened"));
        }
    }

    function handleOnClose() {
        onClose && onClose();

        if (elemCurrent) {
            elemCurrent.dispatchEvent(new CustomEvent("closed"));
        }
    }

    function handleOnSelect(label, value) {
        setSelectedItem(value);
        setPlaceholder(label);
        setDropdownOpen(false);

        handleOnClose();
        onSelect && onSelect(label, value);

        if (elemCurrent) {
            elemCurrent.dispatchEvent(new CustomEvent("selected"));
        }
    }
});
